export const apiRoutes = {
  //UPLOAD IMAGES ROUTES
  routeUploadDriverImage: 'files/managefiles/drivers',
  routeUploadLicenseImage: 'files/managefiles/licences',
  routeUploadVehicleTypeImage: 'files/managefiles/typevehicles'
};
